import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Divider, CardMedia, Grid, Button, IconButton, Icon } from '@mui/material';
import styled from '@emotion/styled';

import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';

import { useFormikContext, FieldArray } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Dialog from '../../../utils/utilities/Dialog';

import useInvoiceActionStore from '../../../store/invoice_actions';

import EditRepairTicket from '../../Repair_Tickets/EditRepairTicket';


const SaveConfirmation = styled.div`
  padding: 1.6rem;
`

const AddRepairs = ({ title = "Add Repairs", wig, stylist, source = "wig" }) => {

  let wig_id = wig?.wig_id;
  let inventory_id = wig?.inventory_id;

  const [openRepairsDialog, setOpenRepairsDialog] = useState(false);

  const { values, submitForm } = useFormikContext() || {};

  const { formValues } = useFormData() || {};

  const pendingIADialog = useInvoiceActionStore((state) => state.pendingIADialog);
  const setPendingIADialog = useInvoiceActionStore((state) => state.setPendingIADialog);
  const setInvoiceData = useInvoiceActionStore((state) => state.setInvoiceData);

  let is_edit = !!values?.invoice_id;

  let invoice_data = {
    invoice_id: values?.invoice_id,
    customer: {
      customer_id: values?.customer_id,
      full_name: formValues?.client_name || values?.client_name
    }
  }

  if (wig_id) {
    invoice_data.wig = {
      wig_id,
      description: wig?.description,
      inventory_id
    }
  }

  if (stylist) {
    invoice_data.stylist_rep = stylist;
  }

  let id = `${values?.customer_id?.toString()}-${source}${wig_id ? `-${wig_id}` : ""}`

  const saveInvoice = () => {
    setPendingIADialog(id);
    submitForm();
  }

  useEffect(() => {
    if (is_edit && pendingIADialog === id) {
      setOpenRepairsDialog(true);
      setInvoiceData(invoice_data);
    }
  }, [is_edit, pendingIADialog])

  return (
    <>
    <Button startIcon={<ContentCutRoundedIcon />} variant="outlined" size="small" sx={{borderRadius: "15px", px: "1.8rem", minWidth: "max-content !important"}} onClick={saveInvoice}>Add Repairs</Button>
    
    <Dialog
      title={title}
      forceOpen={openRepairsDialog}
      forceClose={() => setOpenRepairsDialog(false)}
      fullScreen
      useForm={true}
    >
      <EditRepairTicket dialog={true}/>
    </Dialog>
    </>
  )
};

export default AddRepairs;